<template>
  <BaseSection>
    <div class="success-payment">
      <hgroup>
        <h1 v-t="'success.title'" />
        <h2 v-t="'success.subTitle'" />
      </hgroup>
      <div class="link">
        <a target="_blank" rel="noopener" :href="publishedSiteUrl">{{ publishedSiteDomain }}</a>
      </div>
      <success-payment-dashboard />
      <success-payment-next />
      <success-payment-support />
    </div>
  </BaseSection>
</template>

<script>
import store from '@/store';
import { getPublishedSiteDomain, getPublishedSiteUrl } from '@/utils/getSiteUrls';

import SuccessPaymentDashboard from '@/components/SuccessPaymentDashboard/SuccessPaymentDashboard';
import SuccessPaymentNext from '@/components/SuccessPaymentNext/SuccessPaymentNext';
import SuccessPaymentSupport from '@/components/SuccessPaymentSupport/SuccessPaymentSupport';

export default {
  components: {
    SuccessPaymentDashboard,
    SuccessPaymentNext,
    SuccessPaymentSupport,
  },
  computed: {
    publishedSiteDomain: () => getPublishedSiteDomain(store),
    publishedSiteUrl: () => getPublishedSiteUrl(store),
  },
};
</script>

<style scoped src="./successPayment.css"></style>
